import React, {Component} from 'react';
import Grid from "@material-ui/core/Grid";
import ColAtm from "../../../atomic/Col/Col";
import LabelAtm from "../../../atomic/Label/Label";
import ColorPicker from "rc-color-picker";
import Button from "@material-ui/core/Button";
import BlockAtm from "../../../atomic/Block/Block";
import Card from "@material-ui/core/Card";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ButtonAtm from "../../../atomic/Button/Button";
import Toolbar from "@material-ui/core/Toolbar";
import {Hidden, TextField, Snackbar} from "@material-ui/core";
import Scrollchor from "react-scrollchor";
import {isDefined} from "../../../../utils";
import AppBar from "@material-ui/core/AppBar/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import { connect } from "react-redux";
import { clearOpenAI, openAI } from '../../../../redux/actions/General/OpenAI/openAIActions';
import { getAppLang, getUserToken, getProperty } from '../../../../utils';
import { getLanguages } from '../../../../redux/actions/languageActions';
import { Alert } from '@material-ui/lab';
import axios from 'axios';
import { OPEN_AI } from '../../../../constants/api.constants';
import { propertyProducts } from '../../../../redux/actions/propertyProductsActions';

let t=null;

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`room-rate-tabpanel-${index}`}
            aria-labelledby={`room-rate-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `room-rate-tab-${index}`,
        'aria-controls': `room-rate-tabpanel-${index}`,
    };
}

class FromBrandLast extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title : this.props.get_property_brand.title ? this.props.get_property_brand.title : {},
            color_code_1 : this.props.get_property_brand.color_code_1 ? this.props.get_property_brand.color_code_1 : '',
            color_code_2 : this.props.get_property_brand.color_code_2 ? this.props.get_property_brand.color_code_2 : '',
            color_code_3 : this.props.get_property_brand.color_code_3 ? this.props.get_property_brand.color_code_3 : '',
            photo : this.props.get_property_brand.photo ? this.props.get_property_brand.photo : '',
            logo_name : this.props.get_property_brand.logo_name ? this.props.get_property_brand.logo_name : '',
            imgRef: "",
            colors : this.props.get_property_brand.color_codes && Object.keys(this.props.get_property_brand.color_codes).length > 0 ? this.props.get_property_brand.color_codes :
                [
                    {color_number : 1, color_code : ''},
                    {color_number : 2, color_code : ''}
                ],
            titleCharCount : Object.keys(this.props.get_property_brand.title).length > 0  ? this.props.get_property_brand.title.map(value =>{
                   return value.description === null ? 0 : value.description.length
                }) : [],
            titleMaxCharCount : 1000,
            tabValue : 0,
            brandDelete : !this.props.get_property_brand.logo_file_ext || (this.props.get_property_brand.logo_file_ext === null && this.props.get_property_brand.logo_path === null) ? false : true,
            aiLoading: false,
            languages: [],
            translateLoading: false,
            showSnackbar: false,
        };
        t = props.t;
    }



    componentDidMount() {
        document.body.style.backgroundColor = "#ffffff";
        this.props.getLanguages();
        this.props.propertyProducts();
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onBrandSubmitForm(this.state);
    };

    onFileChange = event => {
        const file = event.target.files[0];

        if(isDefined(file)) {
            this.setState({
                imgRef: URL.createObjectURL(file),
                photo: event.target.files[0]
            });
        }
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleChangeColor = index => (e) => {

        const colors = [...this.state.colors];
        colors[index]['color_code'] = e.color;
        this.setState({
            colors : colors
        });

    }

    handleAddColor = () => {

        let colors = this.state.colors;
        let colorLength = this.state.colors.length + 1;
        let newColors = [
                ...colors,
                { color_number : (colorLength), color_code: '#ffffff'}
            ];
        this.setState({ colors : newColors});

    }

    handleDeleteColor = () => {

        let colorLength = this.state.colors.length;
        let colors = this.state.colors.filter( (color, index) => {
            return (colorLength - 1) !== index;
        });
        this.setState({
            colors: colors
        });

    }

    handleTabChange = ( event, newValue ) => {
        this.setState( {tabValue : newValue});
    };

    handleChangeCharCount = index => (e) => {

        let tempCount = this.state.titleCharCount;
        tempCount[index] = e.target.value.length;

        this.setState({
            titleCharCount:tempCount
        });

        let values = this.state.title;
        values[index]["description"] = e.target.value;
    };

    handleAIResponse = (aiData) => {
        let updatedTitles = this.state.title.map(desc => ({ ...desc }));

        Object.keys(aiData || {}).forEach(lang => {
            const idx = updatedTitles.findIndex(d => d.language_code === lang);
            if (idx !== -1 && aiData[lang]) {
                updatedTitles[idx].description = aiData[lang];
            }
        });

        this.setState({
            title: updatedTitles,
            titleCharCount: updatedTitles.map(d => d.description ? d.description.length : 0),
            aiLoading: false,
            // translateLoading: false
        });
        this.props.clearOpenAI();
    };

    handleTranslateResponse = (aiData, sourceLangCode) => {
        let updatedTitles = this.state.title.map(desc => ({ ...desc }));

        Object.keys(aiData || {}).forEach(lang => {
            if (lang !== sourceLangCode) {
                const idx = updatedTitles.findIndex(d => d.language_code === lang);
                if (idx !== -1 && aiData[lang]) {
                    updatedTitles[idx].description = aiData[lang];
                }
            }
        });

        this.setState({
            title: updatedTitles,
            titleCharCount: updatedTitles.map(d => d.description ? d.description.length : 0),
            translateLoading: false,
            showSnackbar: true,
        });
        // this.props.clearOpenAI();
    };

    handleAIDescription = index => async (e) => {
        this.setState({ aiLoading: true, isTranslateMode: false });
        const langCodes = (this.props.languages || []).map(lang => lang?.name).join(', ');
        
        let aiMessage = [
            {
                role: "system",
                content: "Sen bir SEO uzmanısın. Cevaplarını SADECE JSON formatında ver, veriye sadece açıklamayı dahil et, object keyleri sadece dil kodu olsun. Otelin markası için özgün, açıklayıcı ve SEO uyumlu sloganlar üret"
            },
            {
                role: "user",
                content: `Aşağıdaki bilgilerle ${this.props?.hotel_name || "bu otelin"} markası için özgün ve SEO uyumlu bir slogan oluştur: marka adı ${this.props?.hotel_name}. Slogan maksimum 300 karakter olsun ve kullanıcıyı bilgilendirici olsun. Türkçe dilinde oluştur ve ${langCodes} dillerine çevir.`
            }
        ];
        this.props.openAI({ message: aiMessage });
    };

    handleTranslate = (index, langCode) => async (e) => {
        const currentTitle = this.state.title.find(t => t.language_code === langCode);

        if (!currentTitle?.description || currentTitle.description.trim() === "") {
            return;
        }

        this.setState({ translateLoading: true });

        const sourceLangName = (this.props.languages || []).find(lang => lang.code === langCode)?.name || langCode;
        const targetLangs = (this.props.languages || [])
            .map(lang => ({ code: lang?.code, name: lang?.name }))
            .filter(lang => lang.code && lang.code !== langCode);

        const headers = {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        };

        const makeRequest = (targetLang) => {
            const body = {
                params: {
                    property_id: getProperty(),
                    query: {
                        model: "gpt-4.1-mini",
                        response_format: { type: "json_object" },
                        messages: [
                            {
                                role: "system",
                                content: "Sen profesyonel bir çevirmensin. Cevabını SADECE JSON formatında ver, tek bir key olsun: dil kodu (örn: {\"en\": \"...\"})."
                            },
                            {
                                role: "user",
                                content: `Aşağıdaki ${sourceLangName} dilindeki metni ${targetLang.name} diline çevir. Metin: "${currentTitle.description}". Çeviriyi JSON formatında ver, key olarak "${targetLang.code}" kullan.`
                            }
                        ]
                    }
                }
            };
            return axios.post(OPEN_AI, body, { headers })
                .then(res => res.data.data)
                .catch(() => null);
        };

        try {
            const results = await Promise.all(targetLangs.map(lang => makeRequest(lang)));
            const merged = {};
            results.forEach(result => {
                if (result && typeof result === 'object') Object.assign(merged, result);
            });
            this.handleTranslateResponse(merged, langCode);
        } finally {
            this.setState({ translateLoading: false });
        }
    };

    componentDidUpdate(prevProps) {
        if ((prevProps.brandReducer.brandLogoStatus !== this.props.brandReducer.brandLogoStatus) && this.props.brandReducer.brandLogoStatus === 200) {
           this.setState({
               imgRef : "",
               logo_name : "",
               brandDelete : false
           });
        }

        if((prevProps.brandReducer.updateData !== this.props.brandReducer.updateData) && this.props.brandReducer.updateData === 200){
            this.setState( {brandDelete : true});
        }

        if (this.props.openAIReducer?.listData !== prevProps.openAIReducer?.listData) {
            if (this.props.openAIReducer?.listData) {
                this.handleAIResponse(this.props?.openAIReducer?.listData);
            }
        }
    }

    render() {
        const firstColor = this.state.colors[0].color_code
        const secondColor = this.state.colors[1].color_code

        const colorNumbers = { 0 : 'one', 1 : 'two', 2 : 'three', 3 : 'four', 4 : 'five'};
        
        const { aiLoading, translateLoading } = this.state;

        const sysLang = getAppLang();
        const sortedDescriptions = this.state.title.map((item, idx) => ({ ...item, originalIndex: idx })).sort((a, b) => {
            // Önce tr, sonra en gelsin
            if (a.language_code === "tr") return -1;
            if (b.language_code === "tr") return 1;
            if (a.language_code === "en") return -1;
            if (b.language_code === "en") return 1;
            // Diğer diller alfabetik
            return a.language_code.localeCompare(b.language_code);
        });

        const contentProduct = isDefined(this.props.propertyProductsReducer) &&
            isDefined(this.props.propertyProductsReducer.get_products) &&
            !this.props.propertyProductsReducer.fetching
                ? Object.values(this.props.propertyProductsReducer.get_products.data).find(item => item.route === "content")
                : null;

        const showAIContent = isDefined(contentProduct) &&
            isDefined(contentProduct.parameters) &&
            (contentProduct?.parameters?.length === 0 || contentProduct.parameters.some(p => p?.product_parameter_id === 102 && p?.is_selected === 1));

        const descriptionList = sortedDescriptions?.map((title, index)=>{
            const hasDescription = title?.description && title?.description.trim() !== "";

            return (
                <TabPanel value={this.state.tabValue} index={index} className="w-100">
                    {showAIContent && (
                        <div className='mt-8' style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8, gap: 8 }}>
                            <ButtonAtm
                                size="small"
                                variant="outlined"
                                onClick={this.handleAIDescription(index)}
                                startIcon={
                                    aiLoading ?
                                        <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                        :
                                        <svg xmlns="http://www.w3.org/2000/svg" style={{color: "#d71f26", marginLeft: "8px"}} className="competitor-ai-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
                                            <path d="M20 3v4"></path>
                                            <path d="M22 5h-4"></path>
                                            <path d="M4 17v2"></path>
                                            <path d="M5 18H3"></path>
                                        </svg>
                                }
                                style={{borderRadius: "8px", color: "#000", textTransform: "none"}}
                                buttontext={t('enw-create_with_ai-title')}
                                disabled={this.props.hotel_name === "" || this.props.hotel_name === undefined || aiLoading || translateLoading}
                            />
                            <ButtonAtm
                                size="small"
                                variant="outlined"
                                onClick={this.handleTranslate(index, title.language_code)}
                                startIcon={
                                    translateLoading ?
                                        <i style={{fontSize: "16px", marginLeft: "8px"}} className="fas fa-spinner-third fa-spin"></i>
                                        :
                                        <svg fill="#d71f26" style={{width: "1.5rem", height: "1rem", fontSize: 20}} viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><path d="M39,18.67H35.42l-4.2,11.12A29,29,0,0,1,20.6,24.91a28.76,28.76,0,0,0,7.11-14.49h5.21a2,2,0,0,0,0-4H19.67V2a2,2,0,1,0-4,0V6.42H2.41a2,2,0,0,0,0,4H7.63a28.73,28.73,0,0,0,7.1,14.49A29.51,29.51,0,0,1,3.27,30a2,2,0,0,0,.43,4,1.61,1.61,0,0,0,.44-.05,32.56,32.56,0,0,0,13.53-6.25,32,32,0,0,0,12.13,5.9L22.83,52H28l2.7-7.76H43.64L46.37,52h5.22Zm-15.3-8.25a23.76,23.76,0,0,1-6,11.86,23.71,23.71,0,0,1-6-11.86Zm8.68,29.15,4.83-13.83L42,39.57Z"/></svg>
                                }
                                style={{borderRadius: "8px", color: "#000", textTransform: "none"}}
                                buttontext={t('btn-translate')}
                                disabled={!hasDescription || aiLoading || translateLoading}
                            />
                        </div>
                    )}
                    <TextField 
                        name={title.language_code}
                        type="text"
                        variant="outlined"
                        // className="text-capitalize mt-0"
                        className={showAIContent ? 'text-capitalize mt-0' : 'text-capitalize mt-10' }
                        value={title.description}
                        onChange={this.handleChangeCharCount(title.originalIndex)}
                        label={ t('enw-input-welcome_to_slogan') + " - " + title.language_code }
                        multiline={true}
                        fullWidth
                        required={false}
                        rows={2}
                        inputProps={{maxLength : this.state.titleMaxCharCount}}
                    />
                    <div style={{ width: '100%'}}>
                        <p style={{ float : 'right'}}> { this.state.titleCharCount[title.originalIndex] } / {this.state.titleMaxCharCount}</p>
                    </div>
                </TabPanel>
            );
        })

        const descriptionTabs = sortedDescriptions?.map((title,value)=>{
            const flag = <Grid container className="brand-desc-flag" spacing={1}> <Grid item sm={3}><img src={`${process.env.PUBLIC_URL}/assets/img/language/${title.language_code}.svg`} alt={title.language_code} /> </Grid> <Grid item sm={2}> {title.language_code}</Grid></Grid>
            return (
                    <Tab label={ flag } {...a11yProps(value)} />
            );
        })
        return (
            <ColAtm md={12} lg={12} xl={12}>
                <BlockAtm md={6} lg={6} xs={12}  >
                    <LabelAtm variant="h6" component="h2" text={ t('enw-general-brand-subtitle') } style={{paddingTop: 32}} />
                    <Hidden mdUp>
                        <ExpansionPanel className="location-map-accordion">
                            <ExpansionPanelSummary
                                expandIcon={<i className="fas fa-arrow-down mobile-map-arrow" />}
                                aria-label="Expand"
                                aria-controls="additional-actions1-content"
                                id="additional-actions1-header">
                                <ColAtm>
                                    <ColAtm md={11}>
                                        <i className="fas fa-browser mobile-map-icon" />
                                        <LabelAtm labelClass="room-rate-list-title" text={t('btn-preview')} />
                                    </ColAtm>
                                </ColAtm>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails className="room-rate-detail MuiGrid-root MuiGrid-container MuiGrid-item">
                                <BlockAtm md={6} lg={6} xs={12} className="fullWidthRow" style={{ backgroundColor: '#f4f7fc'}} >
                                    <BlockAtm>
                                        <Card className="mobile-brand-card brand-card">
                                            <ColAtm sm={12} className={"brand-preview"}>
                                                <ColAtm sm={12}>
                                                    <div className="flex-grow-1">
                                                        <Toolbar className="offer-top-menu">
                                                            <ColAtm sm={12}>
                                                                <ColAtm xs={7} sm={5} className="offer-menu-left">
                                                                    <Grid className="brand-logo-box">
                                                                        {
                                                                            this.state.imgRef !== ""  || this.state.logo_name !== "" ?
                                                                                this.state.imgRef !== "" ?
                                                                                    <img src={this.state.imgRef} alt="logo" />
                                                                                    :
                                                                                    <img src={this.state.logo_name} alt="logo" />

                                                                                :
                                                                                <h2>Logo</h2>
                                                                        }
                                                                    </Grid>
                                                                </ColAtm>
                                                                <ColAtm xs={5} sm={7} className="offer-brand-right" style={{backgroundColor: isDefined(firstColor) ? firstColor : "#e2e2e2" }}>
                                                                    <Hidden smDown>
                                                                        <Scrollchor to="#photos" className="nav-link">
                                                                            <Button color="inherit"> { t('enw-general-information-subtitle') } </Button>
                                                                        </Scrollchor>
                                                                    </Hidden>
                                                                    <Hidden smDown>
                                                                        <Scrollchor to="#footer" className="nav-link">
                                                                            <Button color="inherit"> { t('enw-general-tab-communication') }</Button>
                                                                        </Scrollchor>
                                                                    </Hidden>
                                                                </ColAtm>
                                                            </ColAtm>
                                                        </Toolbar>
                                                    </div>
                                                </ColAtm>
                                                <ColAtm sm={5} className="offer-top-left">
                                                    <ColAtm sm={12} className="offer-carousel-height">
                                                        <img src="/assets/img/examples/brand-image.jpg" style={{ width: '130%', height: "260px", marginTop: "10px" }} alt="brand-image" />
                                                    </ColAtm>
                                                </ColAtm>
                                                <ColAtm sm={7} className="brand-top-right" style={{backgroundColor: isDefined(firstColor) ? firstColor : "#e2e2e2" }}>
                                                    <ColAtm sm={2}>
                                                    </ColAtm>
                                                    <ColAtm sm={6} className="m-auto">
                                                        <ColAtm>
                                                            <LabelAtm labelClass="offer-slogan-text" text={this.props.hotel_name} />
                                                        </ColAtm>
                                                        <ColAtm>
                                                            <ButtonAtm
                                                                className={ "brand-show-button"}
                                                                fullwidth={true}
                                                                buttontext={ "Button" }
                                                                style={{backgroundColor: isDefined(secondColor) ? secondColor : "#eaeaea" }}
                                                            />
                                                        </ColAtm>
                                                    </ColAtm>
                                                </ColAtm>
                                                <i className="far fa-long-arrow-down brand-scroll-icon" style={{color: isDefined(this.state.colors[2]) ? this.state.colors[2].color_code : "#e2e2e2"}} />
                                            </ColAtm>
                                        </Card>
                                    </BlockAtm>
                                </BlockAtm>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    </Hidden>
                    <form onSubmit={this.onSubmit} name="general-form" id="general-form" autoComplete="off">
                    <ColAtm>
                            <ColAtm md={11} lg={11} xl={11}>
                                <Grid className="brand-col" item xs={12}>
                                    <ColAtm sm={12} className="d-block mb-55">
                                        <LabelAtm variant="h2" text={ t('enw-input-title-logo') } labelClass="mb-20" />
                                        <Grid container spacing={3}>
                                            <Grid item xs={9} sm={4} md={3}>
                                                <Grid className="brand-logo-box">
                                                    {
                                                        this.state.imgRef !== "" ?
                                                            <img src={this.state.imgRef} alt="logo" />
                                                            :
                                                            <img src={this.state.logo_name} alt="logo" />
                                                    }
                                                </Grid>
                                            </Grid>
                                            {
                                                this.state.brandDelete ? ( <Grid item xs={3} sm={1} className="brand-logo-upload">
                                                    <ButtonAtm className="delete-bed-button" fullwidth={true}
                                                               startIcon={<i className="fas fa-trash" />}
                                                               onClick={() => this.props.clearBrandLogo()}
                                                               disabled={this.props.brandReducer.brandLogoFetching}
                                                    />
                                                </Grid>) : ''
                                            }
                                        </Grid>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={5} className="brand-logo-upload">
                                                <input
                                                    className="d-none"
                                                    accept="image/png, image/jpeg"
                                                    id="contained-button-file"
                                                    multiple
                                                    type="file"
                                                    onChange={this.onFileChange.bind(this)}
                                                />
                                                <label htmlFor="contained-button-file">
                                                    <Button
                                                        className="room-rate-add soft-blue-button m-auto radius-8"
                                                        component="span"
                                                        startIcon={<i className="fas fa-cloud-upload-alt" />}>
                                                        { t('btn-logo_upload') }
                                                    </Button>
                                                </label>
                                            </Grid>
                                        </Grid>
                                    </ColAtm>
                                    <ColAtm className="d-block mb-55">
                                        <LabelAtm variant="h2" text={ t('enw-input-title-colors') } labelClass="mb-20" />
                                        <ColAtm className="color-select">
                                            {this.state.colors.map((color, index) => ( <ColAtm xs={4} sm={2} className="d-block">
                                                <LabelAtm component="h3" text={ t('enw-input-color_'+ colorNumbers[index] ) } />
                                                <ColorPicker
                                                    animation="slide-up"
                                                    defaultColor=""
                                                    color={color.color_code}
                                                    onChange={this.handleChangeColor(index)}
                                                />
                                            </ColAtm>))}
                                            {this.state.colors.length > 2 && (<>
                                                <ColAtm xs={4} sm={1} className="form-group" style={{ paddingTop:45,marginBottom:8,marginRight:45}}>
                                                    <ButtonAtm className="delete-bed-button" fullwidth={true}
                                                               startIcon={<i className="fas fa-minus-circle" />}
                                                               onClick={this.handleDeleteColor}
                                                    />
                                                </ColAtm>
                                            </> ) }
                                            {this.state.colors.length < 5 ? ( <ColAtm xs={4} sm={1} className="form-group" style={{paddingTop:45,marginBottom:8,marginLeft: '-25px'}}>
                                                <ButtonAtm className="new-bed-button w-100"
                                                           startIcon={<i className="fas fa-plus-circle" />}
                                                           onClick={this.handleAddColor}
                                                />
                                            </ColAtm>) : ('')}
                                        </ColAtm>
                                    </ColAtm>
                                    <ColAtm className="d-block mb-55">
                                        <LabelAtm variant="h2" text={ t('enw-input-title-slogan') } />
                                        <ColAtm>

                                            <AppBar className="room-rate-tab-title" position="static">
                                                <Tabs className="room-rate-tabFont"
                                                      value={this.state.tabValue}
                                                      onChange={this.handleTabChange}
                                                      aria-label="room-rate-tab"
                                                      variant="scrollable"
                                                      scrollButtons="on"
                                                >
                                                    {descriptionTabs}
                                                </Tabs>
                                            </AppBar>
                                            {descriptionList}
                                        </ColAtm>
                                    </ColAtm>
                                </Grid>
                            </ColAtm>
                    </ColAtm>
                    </form>
                </BlockAtm>
                <BlockAtm md={6} lg={6} xs={12} className="fullWidthRow mobile-d-none" style={{ backgroundColor: '#f4f7fc', height: '800px'}} >
                    <BlockAtm>
                        <Card className="brand-card">
                            <ColAtm sm={12} className={"brand-preview"}>
                                <ColAtm sm={12}>
                                    <div className="flex-grow-1">
                                        <Toolbar className="offer-top-menu">
                                            <ColAtm sm={12}>
                                                <ColAtm xs={7} sm={5} className="offer-menu-left">
                                                    <Grid className="brand-logo-box">
                                                        {
                                                            this.state.imgRef !== ""  || this.state.logo_name !== "" ?
                                                            this.state.imgRef !== "" ?
                                                                <img src={this.state.imgRef} alt="logo" />
                                                                :
                                                                <img src={this.state.logo_name} alt="logo" />

                                                                :
                                                                <h2>Logo</h2>
                                                        }
                                                    </Grid>
                                                </ColAtm>
                                                <ColAtm xs={5} sm={7} className="offer-brand-right" style={{backgroundColor: isDefined(firstColor) ? firstColor : "#e2e2e2" }}>
                                                    <Hidden smDown>
                                                        <Scrollchor to="#photos" className="nav-link">
                                                            <Button color="inherit"> { t('enw-general-information-subtitle') } </Button>
                                                        </Scrollchor>
                                                    </Hidden>
                                                    <Hidden smDown>
                                                        <Scrollchor to="#footer" className="nav-link">
                                                            <Button color="inherit"> { t('enw-general-tab-communication') }</Button>
                                                        </Scrollchor>
                                                    </Hidden>
                                                </ColAtm>
                                            </ColAtm>
                                        </Toolbar>
                                    </div>
                                </ColAtm>
                                <ColAtm sm={5} className="offer-top-left">
                                    <ColAtm sm={12} className="offer-carousel-height">
                                        <img src="/assets/img/examples/brand-image.jpg" style={{ width: '130%', height: "260px", marginTop: "10px" }} alt="brand-image" />
                                    </ColAtm>
                                </ColAtm>
                                <ColAtm sm={7} className="brand-top-right" style={{backgroundColor: isDefined(firstColor) ? firstColor : "#e2e2e2" }}>
                                    <ColAtm sm={2}>
                                    </ColAtm>
                                    <ColAtm sm={6} className="m-auto">
                                        <ColAtm>
                                            <LabelAtm labelClass="offer-slogan-text" text={this.props.hotel_name} />
                                        </ColAtm>
                                        <ColAtm>
                                            <ButtonAtm
                                                className={ "brand-show-button"}
                                                fullwidth={true}
                                                buttontext={ "Button" }
                                                style={{backgroundColor: isDefined(secondColor) ? secondColor : "#eaeaea" }}
                                            />
                                        </ColAtm>
                                    </ColAtm>
                                </ColAtm>
                                <i className="far fa-long-arrow-down brand-scroll-icon" style={{color: isDefined(this.state.colors[2]) ? this.state.colors[2].color_code : "#e2e2e2"}} />
                            </ColAtm>
                        </Card>
                    </BlockAtm>
                </BlockAtm>
                <style>{`
                    button.Mui-disabled {
                        color:#000 !important;
                    }
                `}</style>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    open={this.state.showSnackbar}
                    autoHideDuration={3000}
                    onClose={() => this.setState({ showSnackbar: false })}
                    style={{ bottom: 80, right: 40, left: 'auto' }}
                >
                    <Alert onClose={() => this.setState({ showSnackbar: false })} severity="success">
                        {t('enw-translated_to_all_languages')}
                    </Alert>
                </Snackbar>
            </ColAtm>
        );
    }
}

FromBrandLast.propTypes = {};

const mapStateToProps = state => ({
    openAIReducer: state.openAIReducer,
    languages: state.languagesReducer.languages,
    propertyProductsReducer: state.propertyProductsReducer,
});

export default compose(withTranslation('common'), connect(mapStateToProps, { openAI, clearOpenAI, getLanguages, propertyProducts }))(FromBrandLast);
